import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full py-20 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-5xl">
        <span className="text-xs font-semibold uppercase tracking-widest text-primary-600/70">
          关于我们
        </span>

        <h2 className="mt-4 text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-primary-800 leading-tight tracking-tight">
          让每一部<br />
          好漫画<br />
          被更多人看见
        </h2>

        <div className="mt-12 max-w-2xl">
          <p className="text-base text-foreground-600 leading-relaxed">
            汗汗漫画诞生于对漫画的无限热爱。我们致力于打造一个<strong>免费、优质、海量</strong>的韩国漫画阅读平台，
            让每一位漫画爱好者都能在这里找到属于自己的故事。无论是甜蜜的恋爱、惊险的悬疑，还是热血的奇幻冒险，
            我们都精心收录，每日更新，只为给你最好的阅读体验。
          </p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start gap-4">
          <Link
            to="/about"
            className="px-7 py-3 rounded-full bg-primary-800 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
          <Link
            to="/category/lianai"
            className="px-7 py-3 rounded-full border border-primary-300 text-primary-700 text-sm font-semibold hover:bg-primary-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览漫画
          </Link>
        </div>
      </div>
    </section>
  );
}